// extracted by mini-css-extract-plugin
module.exports = {"modal":"CorrectDistance--modal--2jujf"};